import {spawnErrorToast} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

export const useOnboardKiln = () => {
  const {t} = useTranslation()

  return useRefraMutation({
    mutationFn: mutations.onboardKiln,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useOnboardKiln')
        .extras({errorDetails})
        .error('Error occurred while onboarding kiln for refractory planning')

      spawnErrorToast(t('error.onboardKiln'))
    }
  })
}
